export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mobile.vue?vue&type=template&id=143255f2"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/mobile.vue?vue&type=template&id=143255f2
// module id = PO/H
// module chunks = 0